import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initOkrObjectiveCommentState: types.OkrObjectiveCommentState = {
    commentList: {},
}

const okrObjectiveCommentReducer = produce((
    draft: types.OkrObjectiveCommentState = initOkrObjectiveCommentState,
    action: ActionTypes = null,
): types.OkrObjectiveCommentState => {
    switch (action.type) {
        case types.OKR_OBJECTIVE_COMMENT_LIST:
            draft.commentList = {
                ...draft.commentList,
                [action.objectiveId]: action.comments,
            }
            return draft

        default:
            return draft
    }
})
export default okrObjectiveCommentReducer
